"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7434],{

/***/ 14826:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Auth_AuthModal; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/sunday-component/node_modules/antd/es/form/index.js + 210 modules
var es_form = __webpack_require__(9117);
// EXTERNAL MODULE: ./src/constants/region.ts
var region = __webpack_require__(7951);
// EXTERNAL MODULE: ./src/utils/appForm.ts
var appForm = __webpack_require__(66885);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/constants/otp.ts
var otp = __webpack_require__(3378);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./src/utils/validationRules.tsx + 1 modules
var validationRules = __webpack_require__(95416);
// EXTERNAL MODULE: ./src/constants/appForm.ts
var constants_appForm = __webpack_require__(43250);
// EXTERNAL MODULE: ./src/api/user.ts
var user = __webpack_require__(50101);
// EXTERNAL MODULE: ./src/api/auth.ts
var auth = __webpack_require__(36707);
// EXTERNAL MODULE: ./src/utils/url.ts
var url = __webpack_require__(65934);
// EXTERNAL MODULE: ./src/constants/params.ts
var params = __webpack_require__(62090);
// EXTERNAL MODULE: ./node_modules/antd/lib/grid/hooks/useBreakpoint.js
var useBreakpoint = __webpack_require__(60872);
// EXTERNAL MODULE: ./src/utils/logger.ts + 1 modules
var logger = __webpack_require__(14744);
// EXTERNAL MODULE: ./src/utils/errors.ts
var errors = __webpack_require__(63197);
// EXTERNAL MODULE: ./src/components/Common/Form/TextBoxForm.tsx
var TextBoxForm = __webpack_require__(71085);
// EXTERNAL MODULE: ./src/constants/error.ts
var constants_error = __webpack_require__(74092);
// EXTERNAL MODULE: ./src/constants/auth.ts
var constants_auth = __webpack_require__(28216);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(6767);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/sunday-component/lib/index.js
var lib = __webpack_require__(58960);
// EXTERNAL MODULE: ./node_modules/antd/es/modal/index.js + 7 modules
var modal = __webpack_require__(35865);
// EXTERNAL MODULE: ./node_modules/antd/es/image/index.js + 23 modules
var es_image = __webpack_require__(96422);
// EXTERNAL MODULE: ./src/styles/globals.ts
var globals = __webpack_require__(60082);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/CheckOutlined.js + 1 modules
var CheckOutlined = __webpack_require__(63606);
// EXTERNAL MODULE: ./node_modules/styled-breakpoints/index.js
var styled_breakpoints = __webpack_require__(94698);
// EXTERNAL MODULE: ./src/components/Common/LinkTitle.tsx
var LinkTitle = __webpack_require__(37262);
// EXTERNAL MODULE: ./src/components/Common/Button.tsx
var Button = __webpack_require__(55267);
;// CONCATENATED MODULE: ./src/components/appForm/Otp/OtpLoginV2.style.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #1c7c4e;\n  font-weight: bold;\n  font-size: 17px;\n  line-height: 18px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: 10px;\n  color: #1c7c4e;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 48px;\n  width: 100%;\n  padding: 0px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-height: 48px;\n  width: 100%;\n  padding: 0px;\n  ",
        " {\n    max-width: ",
        ";\n    margin: 0 auto;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 122px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 444px;\n  .ant-modal-content {\n    border-radius: 16px;\n  }\n  .ant-modal-header {\n    border-radius: 16px 16px 0px 0px;\n  }\n  .ant-modal-close {\n    margin-top: 8px;\n  }\n  .ant-modal-body {\n    padding: 0px;\n  }\n  .ant-modal-close {\n    color: red;\n  }\n  ",
        " {\n    top: 0;\n    margin: 0px;\n    padding: 0px;\n    .ant-modal,\n    .ant-modal-content {\n      height: 100vh;\n      width: 100vw;\n      margin: 0;\n      top: 0;\n    }\n    .ant-modal-footer {\n      display: flex;\n      padding: 16px;\n      position: fixed;\n      bottom: 0;\n      width: 100%;\n      background: white;\n    }\n    .ant-modal-content {\n      border-radius: 0px;\n    }\n    .ant-modal-body {\n      overflow: auto;\n      padding: 0px;\n      width: 100vw;\n      height: calc(100vh - 141px);\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 24px 16px 24px 16px;\n  ",
        " {\n    max-width: ",
        ";\n    margin: auto;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  background-image: url("/static/pages/registerOtp/register-otp-banner-bg.svg");\n  background-repeat: no-repeat;\n  background-size: cover;\n  height: 200px;\n  border-radius: 0% 0% 100% 100% / 0% 0% 20% 20%;\n  overflow: hidden;\n  position: relative;\n  padding: 0 16px;\n  ',
        " {\n    height: 155px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n  margin-top: 36px;\n  ",
        " {\n    margin-top: 0px;\n    max-width: ",
        ";\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 175px;\n  position: absolute;\n  ",
        " {\n    height: 130px;\n    bottom: -8px;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-left: auto;\n  width: fit-content;\n  height: 100%;\n  align-content: center;\n  ",
        " {\n    padding: 24px 16px;\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  margin-top: 6px;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  text-align: center;\n  color: ",
        ";\n"
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  display: flex;\n  items: center;\n  width: 24px;\n  height: 100%;\n  right: 0;\n  top: 0;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  gap: 4px;\n  color: ",
        ";\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 24px;\n  margin-bottom: 24px;\n  max-height: fit-content;\n"
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 4px;\n  cursor: pointer;\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  margin-top: 4px;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0px;\n  .sunday-component-form-item-control {\n    row-gap: 8px;\n  }\n  .sunday-component-form-item-control-input-content > div > div > div > input {\n    width: 100% !important;\n    font-size: 27px;\n    weight: 700;\n    caret-color: ",
        ";\n  }\n  .sunday-component-form-item-control-input-content\n    > div\n    > div\n    > div\n    > input:focus {\n    border-color: ",
        ";\n  }\n  .sunday-component-form-item-control-input-content\n    > div\n    > div\n    > div\n    > input::selection {\n    color: inherit;\n    background: none;\n  }\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}








var maxContentWidth = "343px";
var OtpLoginV2_style_CheckOutlined = (0,styled_components_browser_esm/* default */.ZP)(CheckOutlined/* default */.Z).withConfig({
    componentId: "sc-1a3fa97f-0"
})(_templateObject());
var Verified = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).attrs({
    level: 9
}).withConfig({
    componentId: "sc-1a3fa97f-1"
})(_templateObject1());
var SendOtpButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-1a3fa97f-2"
})(_templateObject2());
var SubmitOtpButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-1a3fa97f-3"
})(_templateObject3(), (0,styled_breakpoints.down)("lg"), maxContentWidth);
var FormItem = (0,styled_components_browser_esm/* default */.ZP)(lib.FormItem).withConfig({
    componentId: "sc-1a3fa97f-4"
})(_templateObject4());
var Space = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a3fa97f-5"
})(_templateObject5());
var Modal = (0,styled_components_browser_esm/* default */.ZP)(modal/* default */.Z).withConfig({
    componentId: "sc-1a3fa97f-6"
})(_templateObject6(), (0,styled_breakpoints.down)("lg"));
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a3fa97f-7"
})(_templateObject7(), (0,styled_breakpoints.down)("lg"), maxContentWidth);
var OtpBannerBg = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a3fa97f-8"
})(_templateObject8(), (0,styled_breakpoints.down)("lg"));
var OtpBanner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a3fa97f-9"
})(_templateObject9(), (0,styled_breakpoints.down)("lg"), maxContentWidth);
var OtpBannerImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a3fa97f-10"
})(_templateObject10(), (0,styled_breakpoints.down)("lg"));
var OtpBannerContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a3fa97f-11"
})(_templateObject11(), (0,styled_breakpoints.down)("lg"));
var BannerTitle = (0,styled_components_browser_esm/* default */.ZP)(lib.Headline).attrs({
    level: 6
}).withConfig({
    componentId: "sc-1a3fa97f-12"
})(_templateObject12(), globals/* color.white */.$.white);
var BannerSubtitle = (0,styled_components_browser_esm/* default */.ZP)(lib.Body).attrs({
    level: 6
}).withConfig({
    componentId: "sc-1a3fa97f-13"
})(_templateObject13(), globals/* color.white */.$.white);
var ModalTitle = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).attrs({
    level: 5
}).withConfig({
    componentId: "sc-1a3fa97f-14"
})(_templateObject14(), globals/* color.charcoal10 */.$.charcoal10);
var ModalCloseIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1a3fa97f-15"
})(_templateObject15());
var CloseIcon = (0,styled_components_browser_esm/* default */.ZP)(es_image/* default */.Z).withConfig({
    componentId: "sc-1a3fa97f-16"
})(_templateObject16());
var SubtitleBody = (0,styled_components_browser_esm/* default */.ZP)(lib.Body).attrs({
    level: 7
}).withConfig({
    componentId: "sc-1a3fa97f-17"
})(_templateObject17(), globals/* color.charcoal09 */.$.charcoal09);
var SubtitleBold = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).attrs({
    level: 7
}).withConfig({
    componentId: "sc-1a3fa97f-18"
})(_templateObject18());
var InputRow = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z).withConfig({
    componentId: "sc-1a3fa97f-19"
})(_templateObject19());
var ButtonTitle = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).withConfig({
    componentId: "sc-1a3fa97f-20"
})(_templateObject20());
var EditButton = (0,styled_components_browser_esm/* default */.ZP)(LinkTitle/* default */.Z).attrs({
    level: 7
}).withConfig({
    componentId: "sc-1a3fa97f-21"
})(_templateObject21());
var ResendButton = (0,styled_components_browser_esm/* default */.ZP)(LinkTitle/* default */.Z).attrs({
    level: 7
}).withConfig({
    componentId: "sc-1a3fa97f-22"
})(_templateObject22());
var ResendWait = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).attrs({
    level: 7
}).withConfig({
    componentId: "sc-1a3fa97f-23"
})(_templateObject23(), globals/* color.charcoal09 */.$.charcoal09);
var OtpField = (0,styled_components_browser_esm/* default */.ZP)(lib.OtpInput).withConfig({
    componentId: "sc-1a3fa97f-24"
})(_templateObject24(), globals/* color.errorRed01 */.$.errorRed01);
var OtpFieldContainer = (0,styled_components_browser_esm/* default */.ZP)(lib.FormItem).withConfig({
    componentId: "sc-1a3fa97f-25"
})(_templateObject25(), globals/* color.carrotOrange */.$.carrotOrange, globals/* color.carrotOrange */.$.carrotOrange);

;// CONCATENATED MODULE: ./src/components/appForm/Otp/OtpLoginModalV2.tsx









var OtpLoginModal = function(param) {
    var disable = param.disable, _loading = param.loading, loading = _loading === void 0 ? false : _loading, otpRef = param.otpRef, otpVerified = param.otpVerified, delay = param.delay, onClickSend = param.onClickSend, onClickSubmit = param.onClickSubmit, target = param.target, form = param.form, isLoading = param.isLoading, otpField = param.otpField, buttonLabels = param.buttonLabels, modalTitle = param.modalTitle, _desktopBreakpoint = param.desktopBreakpoint, desktopBreakpoint = _desktopBreakpoint === void 0 ? false : _desktopBreakpoint;
    var t = (0,useTranslation/* useTranslation */.$)([
        "otp-form",
        "layout"
    ]).t;
    var ref = (0,react.useState)(false), isVisible = ref[0], setIsVisible = ref[1];
    var ref1 = (0,react.useState)(0), count = ref1[0], setCount = ref1[1];
    var isCounting = count !== 0;
    var ref2 = (0,react.useState)(true), disableButton = ref2[0], setDisableButton = ref2[1];
    var inputOtpRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (isCounting) {
            if (count === 0) {
                setCount(0);
            }
            var timer = setInterval(function() {
                setCount(count - 1);
                clearInterval(timer);
            }, 1000);
        }
    }, [
        count,
        isCounting
    ]);
    var sendOtp = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        form.resetFields([
                            otpField
                        ]);
                        return [
                            4,
                            onClickSend(false)
                        ];
                    case 1:
                        _state.sent();
                        setIsVisible(true);
                        return [
                            2
                        ];
                }
            });
        });
        return function sendOtp() {
            return _ref.apply(this, arguments);
        };
    }();
    var resendOtp = function() {
        onClickSend(true);
        setCount(delay);
    };
    var onCancel = function() {
        setIsVisible(false);
    };
    var onEdit = function() {
        setIsVisible(false);
    };
    var verifyOtp = function() {
        onClickSubmit();
    };
    var validateOtp = function(_, value, submitError) {
        if (value && value.length < 6) {
            setDisableButton(true);
            return submitError(/*#__PURE__*/ (0,jsx_runtime.jsx)(TextBoxForm/* TextBoxErrorText */.J9, {
                children: t("otpErrorInvalid")
            }));
        }
        setDisableButton(false);
        return submitError();
    };
    var timerForm = function() {
        var minutes = Math.floor(count / 60) < 10 ? "0".concat(Math.floor(count / 60)) : "".concat(Math.floor(count / 60));
        var seconds = count % 60 < 10 ? "0".concat(count % 60) : "".concat(count % 60);
        return "".concat(minutes, ":").concat(seconds);
    };
    (0,react.useEffect)(function() {
        if (otpVerified) {
            setIsVisible(false);
        }
    }, [
        otpVerified
    ]);
    (0,react.useEffect)(function() {
        var ref;
        (ref = inputOtpRef.current) === null || ref === void 0 ? void 0 : ref.focusInput(0);
    }, [
        isVisible
    ]);
    var _submitButtonLabel, _submitButtonLabel1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SendOtpButton, {
                disabled: disable,
                loading: loading,
                onClick: sendOtp,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonTitle, {
                    level: desktopBreakpoint ? 7 : 8,
                    children: (_submitButtonLabel = buttonLabels.submitButtonLabel) !== null && _submitButtonLabel !== void 0 ? _submitButtonLabel : t("login")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                visible: isVisible,
                centered: desktopBreakpoint,
                closable: true,
                onCancel: onCancel,
                closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {
                    preview: false,
                    src: "/static/pages/planPage/x-icon.svg",
                    alt: "close-icon"
                }),
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalTitle, {
                    children: modalTitle !== null && modalTitle !== void 0 ? modalTitle : t("title")
                }),
                footer: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubmitOtpButton, {
                    onClick: verifyOtp,
                    disabled: disableButton,
                    loading: isLoading,
                    children: (_submitButtonLabel1 = buttonLabels.submitButtonLabel) !== null && _submitButtonLabel1 !== void 0 ? _submitButtonLabel1 : t("submitButton")
                }),
                width: "100vw",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubtitleBody, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                        children: t("subtitle")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                                    gutter: 8,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubtitleBold, {
                                                children: [
                                                    t("subtitleBoldText"),
                                                    " ",
                                                    (0,format/* formatMobileNumber */.IC)(target)
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                            children: !isCounting && /*#__PURE__*/ (0,jsx_runtime.jsx)(EditButton, {
                                                onClick: onEdit,
                                                children: t("editButton")
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubtitleBody, {
                                            children: [
                                                t("reference"),
                                                ": ",
                                                otpRef
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(InputRow, {
                            justify: "space-between",
                            align: "top",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                span: 24,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OtpFieldContainer, {
                                    name: otpField,
                                    rules: [
                                        {
                                            required: true,
                                            message: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBoxForm/* TextBoxErrorText */.J9, {
                                                children: t("otpErrorRequired")
                                            })
                                        },
                                        {
                                            validator: validateOtp
                                        }, 
                                    ],
                                    validateFirst: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OtpField, {
                                        numInputs: 6,
                                        isInputNum: true,
                                        ref: inputOtpRef
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SubtitleBody, {
                            children: t("resendBody")
                        }),
                        !isCounting ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ResendButton, {
                            onClick: resendOtp,
                            children: t("resendButton")
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResendWait, {
                            children: [
                                t("waitResend"),
                                timerForm()
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/appForm/Otp/OtpLoginHelpersV2.tsx












var useLoginOtp = function(param) {
    var active = param.active, method = param.method, form = param.form, code = param.code, field = param.field, lang = param.lang, i18nField = param.i18nField, otpField = param.otpField, errorText = param.errorText, _onFinishVerifying = param.onFinishVerifying, onFinishVerifying = _onFinishVerifying === void 0 ? function() {} : _onFinishVerifying, buttonLabels = param.buttonLabels, modalTitle = param.modalTitle, _desktopBreakpoint = param.desktopBreakpoint, desktopBreakpoint = _desktopBreakpoint === void 0 ? false : _desktopBreakpoint;
    var t = (0,useTranslation/* useTranslation */.$)("layout").t;
    var ref = (0,react.useState)(false), isOtpVerified = ref[0], setIsOtpVerified = ref[1];
    var ref1 = (0,react.useState)(true), isRequestOtpDisable = ref1[0], setIsRequestOtpDisable = ref1[1];
    var ref2 = (0,react.useState)(false), otpLoading = ref2[0], setOtpLoading = ref2[1];
    var ref3 = (0,react.useState)(""), otpRef = ref3[0], setOtpRef = ref3[1];
    var ref4 = (0,react.useState)(0), attempt = ref4[0], setAttempt = ref4[1];
    var ref5 = (0,react.useState)(30), delay = ref5[0], setDelay = ref5[1];
    var ref6 = (0,react.useState)(false), isLoading = ref6[0], setIsLoading = ref6[1];
    var maxShortDelayAttempt = 5;
    var shortDelay = 30;
    var longDelay = 300;
    var onRequestOtp = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(isResend) {
            var mobileNo, res, newOtp, error, isUnknownError;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setOtpLoading(true);
                        if (!(!otpRef || isResend)) return [
                            3,
                            4
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        mobileNo = form.getFieldValue(field);
                        return [
                            4,
                            (0,auth/* sendAuthOtp */.bG)(mobileNo, lang)
                        ];
                    case 2:
                        res = _state.sent();
                        newOtp = res.referenceNumber;
                        setOtpRef(newOtp);
                        setAttempt(attempt + 1);
                        setDelay(attempt < maxShortDelayAttempt ? shortDelay : longDelay);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        isUnknownError = (0,errors/* checkUnknownError */.t)(error);
                        if (isUnknownError) {
                            (0,logger/* logError */.H)("[".concat([
                                code,
                                field,
                                method
                            ], "] send otp fail"), {
                                lang: lang
                            }, error);
                        }
                        setIsRequestOtpDisable(true);
                        form.setFields([
                            {
                                name: otpField,
                                errors: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBoxForm/* TextBoxErrorText */.J9, {
                                        children: errorText != null ? errorText : t("modal.mobileNo.otpError.notSuccess")
                                    })
                                ]
                            }
                        ]);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        setOtpLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function onRequestOtp(isResend) {
            return _ref.apply(this, arguments);
        };
    }();
    var onSubmitOtp = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var otpNo, mobileNo, payload, res, error, isUnknownError, errorMessage;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        otpNo = form.getFieldValue(otpField);
                        mobileNo = form.getFieldValue(field);
                        payload = {
                            otpNo: otpNo,
                            referenceNo: otpRef,
                            mobileNo: mobileNo,
                            grantType: constants_auth/* GRANT_TYPE.OTP */.k.OTP
                        };
                        return [
                            4,
                            (0,auth/* verifyAuth */.RA)(payload)
                        ];
                    case 2:
                        res = _state.sent();
                        if (!res || res.success === false) {
                            form.setFields([
                                {
                                    name: otpField,
                                    errors: [
                                        t("".concat(i18nField, ".otpError.invalid"))
                                    ]
                                }
                            ]);
                            (0,logger/* logError */.H)("[".concat([
                                field,
                                method
                            ], "]submit otp fail"), {
                                lang: lang,
                                referenceNo: otpRef
                            });
                        } else {
                            setIsOtpVerified(true);
                            onFinishVerifying(!res.isAlreadyRegistered);
                        }
                        setIsLoading(false);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        isUnknownError = (0,errors/* checkUnknownError */.t)(error);
                        if (isUnknownError) {
                            (0,logger/* logError */.H)("[".concat([
                                field,
                                method
                            ], "] submit otp fail"), {
                                lang: lang,
                                referenceNo: otpRef
                            }, error);
                        }
                        errorMessage = t("".concat(i18nField, ".otpError.notSuccess"));
                        switch(error.code){
                            case constants_error/* ERROR_CODE.AUTHENTICATION_ERROR */.B.AUTHENTICATION_ERROR:
                                errorMessage = t("".concat(i18nField, ".otpError.invalid"));
                                break;
                            case constants_error/* BUSINESS_ERROR_CODE.EXPIRED */.b.EXPIRED:
                                errorMessage = t("".concat(i18nField, ".otpError.expired"));
                                break;
                            case constants_error/* BUSINESS_ERROR_CODE.OTP_EXCEED_RETRY_ATTEMP */.b.OTP_EXCEED_RETRY_ATTEMP:
                                errorMessage = t("".concat(i18nField, ".otpError.exceedRetryAttemp"));
                                break;
                            case constants_error/* ERROR_CODE.TECHNICAL_ERROR */.B.TECHNICAL_ERROR:
                                errorMessage = t("".concat(i18nField, ".otpError.unavailable"));
                        }
                        form.setFields([
                            {
                                name: otpField,
                                errors: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBoxForm/* TextBoxErrorText */.J9, {
                                        children: errorMessage
                                    })
                                ]
                            }
                        ]);
                        setIsLoading(false);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function onSubmitOtp() {
            return _ref.apply(this, arguments);
        };
    }();
    var OtpFormSuffix = active && /*#__PURE__*/ (0,jsx_runtime.jsx)(OtpLoginModal, {
        otpField: otpField,
        disable: isRequestOtpDisable,
        loading: otpLoading,
        otpRef: otpRef,
        delay: delay,
        onClickSend: onRequestOtp,
        onClickSubmit: onSubmitOtp,
        otpVerified: isOtpVerified,
        target: form.getFieldValue(field),
        form: form,
        isLoading: isLoading,
        method: method,
        buttonLabels: buttonLabels,
        modalTitle: modalTitle,
        desktopBreakpoint: desktopBreakpoint
    });
    return {
        OtpFormSuffix: OtpFormSuffix,
        setIsRequestOtpDisable: setIsRequestOtpDisable,
        isOtpVerified: isOtpVerified,
        setOtpRef: setOtpRef,
        setIsOtpVerified: setIsOtpVerified
    };
};

// EXTERNAL MODULE: ./src/components/Auth/AuthModal.style.tsx
var AuthModal_style = __webpack_require__(78993);
// EXTERNAL MODULE: ./src/components/appForm/ConsentModal.tsx
var ConsentModal = __webpack_require__(7949);
;// CONCATENATED MODULE: ./src/components/Auth/AuthModal.tsx




























var AuthModal = function(param) {
    var _visible = param.visible, visible = _visible === void 0 ? false : _visible, _onClose = param.onClose, onClose = _onClose === void 0 ? function() {} : _onClose;
    var t = (0,useTranslation/* useTranslation */.$)([
        "layout",
        "error-dialog"
    ]).t;
    var ref = (0,router.useRouter)(), locale = ref.locale, asPath = ref.asPath, reload = ref.reload, push = ref.push, query = ref.query;
    var ref1 = (0,_sliced_to_array/* default */.Z)(es_form/* default.useForm */.Z.useForm(), 1), form = ref1[0];
    var ref2 = (0,react.useState)(false), isLoading = ref2[0], setIsLoading = ref2[1];
    var ref3 = (0,react.useState)(false), isConsentVisible = ref3[0], setIsConsentVisible = ref3[1];
    var ref4 = (0,react.useState)(false), isCancelConsentVisible = ref4[0], setIsCancelConsentVisible = ref4[1];
    var ref5 = (0,react.useState)(false), isWelcomeModalVisible = ref5[0], setIsWelcomeModalVisible = ref5[1];
    var ref6 = (0,react.useState)(false), isErrorModalVisible = ref6[0], setIsErrorModalVisible = ref6[1];
    var xl = (0,useBreakpoint/* default */.Z)().xl;
    var redirectLink = asPath;
    var currentPage = "".concat("https://retail.easysunday.com").concat(asPath);
    var mobileNoField = "mobileNo";
    var consentCode = constants_appForm/* CONSENT_CODE.SUNDAY_TC */.xM.SUNDAY_TC;
    var closeAllModals = function() {
        onClose(false);
        setIsConsentVisible(false);
        setIsCancelConsentVisible(false);
        setIsErrorModalVisible(false);
    };
    var onFinishVerified = function(isRegister) {
        if (isRegister) {
            setIsConsentVisible(true);
        } else {
            reload();
        }
    };
    var ref7 = useLoginOtp({
        active: true,
        method: otp/* OTP_METHOD.SMS */.Q.SMS,
        form: form,
        code: "basic-insured-person",
        field: mobileNoField,
        lang: locale,
        otpField: "mobileOtp",
        i18nField: "modal.mobileNo",
        errorText: undefined,
        urlLink: redirectLink,
        buttonLabels: {
            submitButtonLabel: t("modal.submitButton"),
            verifyButtonLabel: t("modal.submitButton")
        },
        modalTitle: t("modal.title"),
        desktopBreakpoint: xl,
        onFinishVerifying: onFinishVerified
    }), OtpFormSuffixMobile = ref7.OtpFormSuffix, setIsRequestOtpDisable = ref7.setIsRequestOtpDisable, setOtpRefMobile = ref7.setOtpRef, setOtpVerifiedMobile = ref7.setIsOtpVerified;
    var onCancelConsent = function() {
        setIsCancelConsentVisible(true);
    };
    var onAgreeConsent = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var updateConsentsPayload, error, ref, response, issueTitle, message;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsLoading(true);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        updateConsentsPayload = {
                            consents: (0,_define_property/* default */.Z)({}, consentCode, true)
                        };
                        return [
                            4,
                            (0,user/* updateUser */.N)(updateConsentsPayload)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            (0,user/* createUser */.r)()
                        ];
                    case 3:
                        _state.sent();
                        closeAllModals();
                        setIsWelcomeModalVisible(true);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        error = _state.sent();
                        response = error.response;
                        issueTitle = "Unknown Error Occurred with status code ".concat(response.status);
                        if (error.code && error.type) {
                            issueTitle = "[".concat(error === null || error === void 0 ? void 0 : error.code, "] ").concat(error === null || error === void 0 ? void 0 : error.type);
                        }
                        message = error.message || (response === null || response === void 0 ? void 0 : (ref = response.data) === null || ref === void 0 ? void 0 : ref.message);
                        setIsErrorModalVisible(true);
                        (0,logger/* logError */.H)(message, response.data, response, issueTitle);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        setIsLoading(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function onAgreeConsent() {
            return _ref.apply(this, arguments);
        };
    }();
    var validateMobileNumber = function(_, value, submitError) {
        if (!region/* MOBILE_NO_PATTERN.test */.DW.test(value)) {
            return submitError(/*#__PURE__*/ (0,jsx_runtime.jsx)(TextBoxForm/* TextBoxErrorText */.J9, {
                children: t("modal.mobileNo.error.pattern")
            }));
        }
        setOtpRefMobile("");
        return submitError();
    };
    var handleOnChangeMobile = function() {
        setOtpVerifiedMobile(false);
    };
    var onFieldsChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if ((0,lodash.isEmpty)(form.getFieldError(mobileNoField))) {
                    setIsRequestOtpDisable(false);
                } else {
                    setIsRequestOtpDisable(true);
                }
                return [
                    2
                ];
            });
        });
        return function onFieldsChange() {
            return _ref.apply(this, arguments);
        };
    }();
    var onCancel = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            (0,auth/* logout */.kS)()
                        ];
                    case 1:
                        _state.sent();
                        reload();
                        return [
                            2
                        ];
                }
            });
        });
        return function onCancel() {
            return _ref.apply(this, arguments);
        };
    }();
    var onGetStart = function() {
        push({
            pathname: "/user/sign-up/personal-profile",
            query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,url/* filterParams */.Lt)(query, params/* GLOBAL_PARAMS */.g_)), {
                r: currentPage
            })
        });
    };
    var onCloseErrorModal = function() {
        closeAllModals();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* LoginModal */._A, {
                centered: xl,
                visible: visible,
                onCancel: function() {
                    return onClose(false);
                },
                footer: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* Form */.l0, {
                    "data-testid": "login-otp-form",
                    form: form,
                    onFieldsChange: onFieldsChange,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* FormItem */.xJ, {
                        children: OtpFormSuffixMobile
                    })
                }),
                closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* CloseIcon */.Tw, {
                    preview: false,
                    src: "/static/pages/planPage/x-icon.svg",
                    alt: "close-icon"
                }),
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* ModalTitle */.r6, {
                    children: t("modal.title")
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuthModal_style/* LoginModalBody */.Fj, {
                    children: [
                        t("modal.subtitle"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* Form */.l0, {
                            "data-testid": "login-form",
                            form: form,
                            onFieldsChange: onFieldsChange,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* FormItem */.xJ, {
                                className: mobileNoField,
                                name: mobileNoField,
                                validateFirst: true,
                                rules: (0,_to_consumable_array/* default */.Z)((0,validationRules/* transformToAntValidations */.p_)([
                                    {
                                        rule: "required"
                                    }
                                ], t, t("modal.mobileNo.label").toLowerCase(), false, TextBoxForm/* TextBoxErrorText */.J9)).concat([
                                    {
                                        validator: validateMobileNumber
                                    }, 
                                ]),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBoxForm/* default */.ZP, {
                                    type: "number",
                                    onChange: handleOnChangeMobile,
                                    onKeyPress: appForm/* handleOnKeyPressNumberEvent */.$S,
                                    onPaste: appForm/* handleOnPasteNumberEvent */.sP,
                                    placeholder: t("modal.mobileNo.placeholder"),
                                    label: t("modal.mobileNo.label")
                                }, mobileNoField)
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConsentModal/* default */.Z, {
                code: consentCode,
                visible: isConsentVisible,
                lang: locale,
                title: t("modal.consent.title"),
                onCloseModal: onCancelConsent,
                footer: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* SubmitButton */.Mm, {
                    onClick: onAgreeConsent,
                    loading: isLoading,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* ButtonTitle */.gQ, {
                        children: t("modal.consent.submitButton")
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* CancelModal */.h4, {
                visible: isCancelConsentVisible,
                onCancel: onCancel,
                centered: true,
                closable: false,
                maskClosable: false,
                footer: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* SubmitButton */.Mm, {
                        onClick: function() {
                            return setIsCancelConsentVisible(false);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* ButtonTitle */.gQ, {
                            children: t("modal.cancelConsent.submitButton")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* SubmitButton */.Mm, {
                        onClick: onCancel,
                        type: "outlined",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* ButtonTitle */.gQ, {
                            children: t("modal.cancelConsent.cancelButton")
                        })
                    }), 
                ],
                title: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* ModalTitle */.r6, {
                    children: t("modal.cancelConsent.title")
                }),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* CancelModalBody */.kU, {
                    children: t("modal.cancelConsent.subtitle")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuthModal_style/* WelcomeModal */.Pe, {
                visible: isWelcomeModalVisible,
                centered: true,
                closable: false,
                maskClosable: false,
                footer: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* SubmitButton */.Mm, {
                        onClick: onGetStart,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* ButtonTitle */.gQ, {
                            children: t("modal.welcome.button")
                        })
                    }), 
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* WelcomeBanner */.cv, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* WelcomeBannerImage */.z7, {
                            preview: false,
                            src: "/static/pages/registerOtp/register-welcome.svg",
                            alt: "welcome-image"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuthModal_style/* WelcomeModalBody */.t_, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* ModalTitle */.r6, {
                                children: t("modal.welcome.title")
                            }),
                            t("modal.welcome.subtitle")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* ErrorModal */.Cv, {
                title: t("error-dialog:title"),
                description: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal_style/* ErrorModalBody */.D, {
                    children: t("error-dialog:description")
                }),
                errorButtons: [
                    {
                        text: t("error-dialog:closeButton"),
                        onClick: function() {
                            return onCloseErrorModal();
                        }
                    }, 
                ],
                isVisible: isErrorModalVisible,
                width: "303px"
            })
        ]
    });
};
/* harmony default export */ var Auth_AuthModal = (AuthModal);


/***/ }),

/***/ 77208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87379);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27049);
/* harmony import */ var src_styles_globals__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60082);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-top: 1px solid ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var Divider = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-99dc03f9-0"
})(_templateObject(), src_styles_globals__WEBPACK_IMPORTED_MODULE_3__/* .color.charcoal03 */ .$.charcoal03);
/* harmony default export */ __webpack_exports__["Z"] = (Divider);


/***/ }),

/***/ 87434:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ProfileHeader_ProfileHeader; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/sunday-component/lib/index.js
var lib = __webpack_require__(58960);
// EXTERNAL MODULE: ./src/components/Auth/AuthModal.tsx + 3 modules
var AuthModal = __webpack_require__(14826);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 7 modules
var esm = __webpack_require__(66934);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./src/styles/globals.ts
var globals = __webpack_require__(60082);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/utils/maskData.ts
var maskData = __webpack_require__(65791);
// EXTERNAL MODULE: ./src/api/auth.ts
var auth = __webpack_require__(36707);
// EXTERNAL MODULE: ./src/utils/logger.ts + 1 modules
var logger = __webpack_require__(14744);
// EXTERNAL MODULE: ./src/utils/url.ts
var url = __webpack_require__(65934);
// EXTERNAL MODULE: ./src/constants/params.ts
var params = __webpack_require__(62090);
// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(6767);
// EXTERNAL MODULE: ./src/components/Common/Header/SundayLogo/SundayLogo.tsx
var SundayLogo = __webpack_require__(5671);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/UpOutlined.js + 1 modules
var UpOutlined = __webpack_require__(48115);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/DownOutlined.js + 1 modules
var DownOutlined = __webpack_require__(80882);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/antd/es/col/index.js
var col = __webpack_require__(15746);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/antd/es/drawer/index.js + 5 modules
var drawer = __webpack_require__(84131);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./src/components/Common/Header/ProfileHeader/ProfileMainMenu/SubMenuDrawer.style.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        " !important;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-shadow: none;\n  z-index: 20;\n  .ant-drawer-body {\n    padding: 0;\n    height: fit-content;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  height: 121px;\n  width: 100%;\n  margin: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 19px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  vertical-align: middle;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  max-width: 1400px;\n\n  a {\n    color: #2a2c2e;\n  }\n  a * {\n    color: #2a2c2e;\n  }\n  a:hover {\n    color: #fa4616;\n  }\n  a:hover * {\n    color: #fa4616;\n  }\n  padding-top: 2.5rem;\n  line-height: 36px;\n  color: #76777a;\n\n  * {\n    color: #76777a;\n  }\n  ul {\n    padding-top: 1rem;\n    padding-left: 0;\n    margin-bottom: 2.5rem;\n    list-style-type: none;\n  }\n  li {\n    padding-top: 0.5rem;\n    list-style: none;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}




var Title = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).withConfig({
    componentId: "sc-337d6885-0"
})(_templateObject(), globals/* color.charcoal10 */.$.charcoal10);
var DrawerContainer = (0,styled_components_browser_esm/* default */.ZP)(drawer/* default */.Z).withConfig({
    componentId: "sc-337d6885-1"
})(_templateObject1());
var HorizontalDivider = styled_components_browser_esm/* default.hr.withConfig */.ZP.hr.withConfig({
    componentId: "sc-337d6885-2"
})(_templateObject2());
var Submenu = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-337d6885-3"
})(_templateObject3());
var SubmenuContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-337d6885-4"
})(_templateObject4());

;// CONCATENATED MODULE: ./src/components/Common/Header/ProfileHeader/ProfileMainMenu/SubMenuDrawer.tsx






var SubMenuDrawer = function(param) {
    var visible = param.visible, onClose = param.onClose;
    var ref = (0,useTranslation/* useTranslation */.$)("layout"), t = ref.t, i18n = ref.i18n;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DrawerContainer, {
        closable: false,
        placement: "top",
        visible: visible,
        onClose: onClose,
        height: "660",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HorizontalDivider, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Submenu, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubmenuContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                                span: 7,
                                offset: 3,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                        level: 5,
                                        children: t("header.healthInsurance.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://retail.easysunday.com/".concat(i18n.language, "/health"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                                                        level: 7,
                                                        children: t("header.healthInsurance.lumpSum")
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://retail.easysunday.com/".concat(i18n.language, "/axa-child-health"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                                                        level: 7,
                                                        children: t("header.healthInsurance.child")
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://retail.easysunday.com/".concat(i18n.language, "/#accident"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                                                        level: 7,
                                                        children: t("header.healthInsurance.personalAccident")
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://retail.easysunday.com/".concat(i18n.language),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                                                        level: 7,
                                                        children: t("header.healthInsurance.allProducts")
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                        level: 5,
                                        children: t("header.motorInsurance.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://retail.easysunday.com/".concat(i18n.language, "/sunday-car-insurance-ev"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                                                        level: 7,
                                                        children: t("header.motorInsurance.ev")
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://retail.easysunday.com/".concat(i18n.language, "/sunday-car-insurance"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                                                        level: 7,
                                                        children: t("header.motorInsurance.motor")
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://easysunday.com/".concat(i18n.language, "/motor"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                                                        level: 7,
                                                        children: t("header.motorInsurance.allProducts")
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://easysunday.com/".concat(i18n.language, "/motor/claim"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                                                        level: 7,
                                                        children: t("header.motorInsurance.claim")
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://easysunday.com/".concat(i18n.language, "/motor/#partnergarage"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                                                        level: 7,
                                                        children: t("header.motorInsurance.sundayPartner")
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                                span: 6,
                                offset: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                        level: 5,
                                        children: t("header.sundayHealthForBusiness.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://easysunday.com/".concat(i18n.language, "/our-product/health/"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                                                        level: 7,
                                                        children: t("header.sundayHealthForBusiness.about")
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://easysunday.com/".concat(i18n.language, "/our-product/health/#owner"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                                                        level: 7,
                                                        children: t("header.sundayHealthForBusiness.forBusinessOwner")
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://easysunday.com/".concat(i18n.language, "/our-product/health/#employee"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                                                        level: 7,
                                                        children: t("header.sundayHealthForBusiness.forEmployee")
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://sundayinsurance.co.th/".concat(i18n.language, "/services/panel/?type=hospital-suncare"),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                                                        level: 7,
                                                        children: t("header.sundayHealthForBusiness.sundayHospitalNetwork")
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                        level: 5,
                                        children: t("header.gadgetWarranty.title")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "https://easysunday.com/".concat(i18n.language, "/warranty/"),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.Body, {
                                                    level: 7,
                                                    children: t("header.gadgetWarranty.claim")
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var ProfileMainMenu_SubMenuDrawer = (SubMenuDrawer);

;// CONCATENATED MODULE: ./src/components/Common/Header/ProfileHeader/ProfileMainMenu/MainMenu.style.tsx

function MainMenu_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    MainMenu_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MainMenu_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: 1rem;\n  font-size: 14px;\n"
    ]);
    MainMenu_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MainMenu_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n"
    ]);
    MainMenu_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function MainMenu_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-right: 32px;\n  :last-of-type {\n    margin-right: 0px;\n  }\n"
    ]);
    MainMenu_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function MainMenu_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: #2b2b2b;\n  :hover {\n    color: #ff875e;\n  }\n"
    ]);
    MainMenu_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  :hover {\n    color: #ff875e;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var MainMenuContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-43956784-0"
})(MainMenu_style_templateObject());
var UpDownIcon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-43956784-1"
})(MainMenu_style_templateObject1());
var MainMenuUl = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-43956784-2"
})(MainMenu_style_templateObject2());
var MainMenuLi = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-43956784-3"
})(MainMenu_style_templateObject3());
var MainMenuLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-43956784-4"
})(MainMenu_style_templateObject4());
var MainMenuBody = (0,styled_components_browser_esm/* default */.ZP)(lib.Body).withConfig({
    componentId: "sc-43956784-5"
})(_templateObject5());
var MainMenuText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-43956784-6"
})(_templateObject6());

;// CONCATENATED MODULE: ./src/components/Common/Header/ProfileHeader/ProfileMainMenu/MainMenu.tsx
/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable jsx-a11y/anchor-is-valid */ /* eslint-disable react/require-default-props */ /* eslint-disable @typescript-eslint/no-unused-vars */ 








var MainMenu = function(param) {
    var subMenuVisible = param.subMenuVisible, setSubMenuVisible = param.setSubMenuVisible, menus = param.menus;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var ref10 = (0,useTranslation/* useTranslation */.$)("layout"), t = ref10.t, i18n = ref10.i18n;
    var router = (0,next_router.useRouter)();
    var channelPath = typeof router.query.channelPath === "object" ? (ref = router.query.channelPath) === null || ref === void 0 ? void 0 : ref[0] : router.query.channelPath;
    var triggerSubMenu = function() {
        return setSubMenuVisible(!subMenuVisible);
    };
    var closeSubMenu = function() {
        return setSubMenuVisible(false);
    };
    var handleGoToAffiliatePage = function() {
        router.push({
            pathname: (0,url/* formatPathByLogicalGroupChannel */.j4)("/".concat(channelPath, "/affiliate")),
            query: (0,url/* filterParams */.Lt)(router.query, params/* GLOBAL_PARAMS */.g_)
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainMenuUl, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuLi, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuLink, {
                                onClick: triggerSubMenu,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainMenuBody, {
                                    level: 5,
                                    children: [
                                        t("header.buyOnline"),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(UpDownIcon, {
                                            children: subMenuVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(UpOutlined/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(DownOutlined/* default */.Z, {})
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuLi, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuText, {
                                onClick: handleGoToAffiliatePage,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuBody, {
                                    level: 5,
                                    children: (menus === null || menus === void 0 ? void 0 : (ref1 = menus.sundayAffiliate) === null || ref1 === void 0 ? void 0 : ref1.label) || t("header.sundayAffiliate")
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuLi, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuLink, {
                                href: (menus === null || menus === void 0 ? void 0 : (ref2 = menus.faq) === null || ref2 === void 0 ? void 0 : ref2.href) || "https://easysunday.com/".concat(i18n.language, "/faq"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuBody, {
                                    level: 5,
                                    children: (menus === null || menus === void 0 ? void 0 : (ref3 = menus.faq) === null || ref3 === void 0 ? void 0 : ref3.label) || t("header.faq")
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuLi, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuLink, {
                                href: (menus === null || menus === void 0 ? void 0 : (ref4 = menus.blog) === null || ref4 === void 0 ? void 0 : ref4.href) || "https://easysunday.com/blog",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuBody, {
                                    level: 5,
                                    children: (menus === null || menus === void 0 ? void 0 : (ref5 = menus.blog) === null || ref5 === void 0 ? void 0 : ref5.label) || t("header.blog")
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuLi, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuLink, {
                                href: (menus === null || menus === void 0 ? void 0 : (ref6 = menus.contactUs) === null || ref6 === void 0 ? void 0 : ref6.href) || "https://easysunday.com/".concat(i18n.language, "/contact-us"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuBody, {
                                    level: 5,
                                    children: (menus === null || menus === void 0 ? void 0 : (ref7 = menus.contactUs) === null || ref7 === void 0 ? void 0 : ref7.label) || t("header.contactus")
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuLi, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuLink, {
                                href: (menus === null || menus === void 0 ? void 0 : (ref8 = menus.aboutUs) === null || ref8 === void 0 ? void 0 : ref8.href) || "https://about.easysunday.com",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MainMenuBody, {
                                    level: 5,
                                    children: (menus === null || menus === void 0 ? void 0 : (ref9 = menus.aboutUs) === null || ref9 === void 0 ? void 0 : ref9.label) || t("header.about")
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileMainMenu_SubMenuDrawer, {
                visible: subMenuVisible,
                onClose: closeSubMenu
            })
        ]
    });
};
/* harmony default export */ var ProfileMainMenu_MainMenu = (MainMenu);

// EXTERNAL MODULE: ./node_modules/antd/es/menu/index.js + 3 modules
var menu = __webpack_require__(38792);
// EXTERNAL MODULE: ./node_modules/@ant-design/icons/es/icons/MenuOutlined.js + 1 modules
var MenuOutlined = __webpack_require__(60532);
// EXTERNAL MODULE: ./node_modules/antd/es/button/index.js
var es_button = __webpack_require__(71577);
;// CONCATENATED MODULE: ./src/components/Common/Header/ProfileHeader/ProfileMainMenu/MobileMainMenu.style.tsx

function MobileMainMenu_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: bold;\n  color: #2a2c2e !important;\n  label {\n    position: absolute;\n    left: 0px;\n  }\n  ul > li {\n    border-right: none !important;\n    font-size: 21px;\n    font-weight: normal;\n  }\n  .ant-menu-submenu-title {\n    padding-left: 0px !important;\n    padding-right: 0px !important;\n\n    :hover {\n      color: #fa4616;\n    }\n  }\n"
    ]);
    MobileMainMenu_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MobileMainMenu_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    MobileMainMenu_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function MobileMainMenu_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  color: #2b2b2b;\n\n  span {\n    font-size: 24px !important;\n  }\n\n  * {\n    color: #2b2b2b;\n  }\n"
    ]);
    MobileMainMenu_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function MobileMainMenu_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px;\n"
    ]);
    MobileMainMenu_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function MobileMainMenu_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-right: none !important;\n  font-size: 21px;\n  a {\n    color: #2a2c2e;\n    white-space: normal;\n    :hover {\n      color: #fa4616;\n    }\n  }\n  i {\n    width: 26px;\n  }\n  i::after {\n    background-color: #2a2c2e;\n    width: 13px;\n    height: 2.5px;\n    left: 21px;\n  }\n  i::before {\n    width: 13px;\n    height: 2.5px;\n    right: -12px;\n    background-color: #2a2c2e;\n  }\n  .ant-menu-item:active,\n  .ant-menu-submenu-title:active {\n    background-color: #ffefe6;\n  }\n\n  .ant-menu-title-content {\n    line-height: 22px;\n  }\n"
    ]);
    MobileMainMenu_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function MobileMainMenu_style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: 0px !important;\n  padding-right: 0px !important;\n"
    ]);
    MobileMainMenu_style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function MobileMainMenu_style_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 16px;\n"
    ]);
    MobileMainMenu_style_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  img {\n    padding: 8px;\n    margin-right: 1em;\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  align-self: center;\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 16px;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  color: ",
        ";\n  :hover {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}




var MenuSubMenu = (0,styled_components_browser_esm/* default */.ZP)(menu/* default.SubMenu */.Z.SubMenu).withConfig({
    componentId: "sc-5cc446a2-0"
})(MobileMainMenu_style_templateObject());
var MobileMenu = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5cc446a2-1"
})(MobileMainMenu_style_templateObject1());
var MenuButton = (0,styled_components_browser_esm/* default */.ZP)(es_button/* default */.Z).withConfig({
    componentId: "sc-5cc446a2-2"
})(MobileMainMenu_style_templateObject2());
var MobileMainMenu_style_DrawerContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5cc446a2-3"
})(MobileMainMenu_style_templateObject3());
var MobileMenuContainer = (0,styled_components_browser_esm/* default */.ZP)(menu/* default */.Z).withConfig({
    componentId: "sc-5cc446a2-4"
})(MobileMainMenu_style_templateObject4());
var MenuItem = (0,styled_components_browser_esm/* default */.ZP)(menu/* default.Item */.Z.Item).withConfig({
    componentId: "sc-5cc446a2-5"
})(MobileMainMenu_style_templateObject5());
var MobileMenuLinkBar = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5cc446a2-6"
})(MobileMainMenu_style_templateObject6());
var MobileMenuLinkIcon = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-5cc446a2-7"
})(_templateObject7());
var ChangeLangItem = (0,styled_components_browser_esm/* default */.ZP)(col/* default */.Z).withConfig({
    componentId: "sc-5cc446a2-8"
})(_templateObject8());
var ChangeLangContainer = (0,styled_components_browser_esm/* default */.ZP)(row/* default */.Z).withConfig({
    componentId: "sc-5cc446a2-9"
})(_templateObject9());
var ChangeLangText = (0,styled_components_browser_esm/* default */.ZP)(lib.Body).withConfig({
    componentId: "sc-5cc446a2-10"
})(_templateObject10(), globals/* color.charcoal08 */.$.charcoal08);
var MenuText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-5cc446a2-11"
})(_templateObject11(), globals/* color.charcoal10 */.$.charcoal10, globals/* color.carrotOrange03 */.$.carrotOrange03);

;// CONCATENATED MODULE: ./src/components/Common/Header/ProfileHeader/ProfileMainMenu/MobileMainMenu.tsx
/* eslint-disable jsx-a11y/no-static-element-interactions */ /* eslint-disable jsx-a11y/click-events-have-key-events */ /* eslint-disable @next/next/no-img-element */ /* eslint-disable react/require-default-props */ 









var MobileMainMenu = function(param) {
    var availableLanguage = param.availableLanguage, onChangeLanguage = param.onChangeLanguage, language = param.language, showSwitch = param.showSwitch, menus = param.menus;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    var ref10 = (0,react.useState)(false), mobileMenuVisible = ref10[0], setMobileMenuVisible = ref10[1];
    var ref11 = (0,useTranslation/* useTranslation */.$)("layout"), t = ref11.t, i18n = ref11.i18n;
    var router = (0,next_router.useRouter)();
    var channelPath = typeof router.query.channelPath === "object" ? (ref = router.query.channelPath) === null || ref === void 0 ? void 0 : ref[0] : router.query.channelPath;
    var handleGoToAffiliatePage = function() {
        router.push({
            pathname: (0,url/* formatPathByLogicalGroupChannel */.j4)("/".concat(channelPath, "/affiliate")),
            query: (0,url/* filterParams */.Lt)(router.query, params/* GLOBAL_PARAMS */.g_)
        });
    };
    var triggerMobileMenu = function() {
        return setMobileMenuVisible(!mobileMenuVisible);
    };
    var closeMobileMenu = function() {
        return setMobileMenuVisible(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileMenu, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuButton, {
                    type: "text",
                    onClick: triggerMobileMenu,
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuOutlined/* default */.Z, {
                        width: 24,
                        height: 24
                    }),
                    size: "large"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(drawer/* default */.Z, {
                    closable: false,
                    placement: "right",
                    onClose: closeMobileMenu,
                    visible: mobileMenuVisible,
                    width: "300",
                    bodyStyle: {
                        padding: "0px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileMainMenu_style_DrawerContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileMenuContainer, {
                                selectable: false,
                                mode: "inline",
                                inlineIndent: 14,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChangeLangContainer, {
                                        justify: "space-between",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangeLangItem, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangeLangText, {
                                                    level: 7,
                                                    children: t("header.changeLanguage")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChangeLangItem, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.LanguageSwitcher, {
                                                    availableLanguages: availableLanguage,
                                                    showSwitch: showSwitch,
                                                    onChangeLanguage: onChangeLanguage,
                                                    language: language
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* default.Divider */.Z.Divider, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: "https://easysunday.com/".concat(i18n.language, "/"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: t("header.home")
                                            })
                                        })
                                    }, "0"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* default.Divider */.Z.Divider, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuSubMenu, {
                                        title: t("header.healthInsurance.title"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* default.Item */.Z.Item, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://retail.easysunday.com/".concat(i18n.language, "/health"),
                                                    children: t("header.healthInsurance.lumpSum")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* default.Item */.Z.Item, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://retail.easysunday.com/".concat(i18n.language, "/axa-child-health"),
                                                    children: t("header.healthInsurance.child")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* default.Item */.Z.Item, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://retail.easysunday.com/".concat(i18n.language, "/#accident"),
                                                    children: t("header.healthInsurance.personalAccident")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* default.Item */.Z.Item, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://retail.easysunday.com/".concat(i18n.language),
                                                    children: t("header.healthInsurance.allProducts")
                                                })
                                            })
                                        ]
                                    }, "sub1"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuSubMenu, {
                                        title: t("header.motorInsurance.title"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* default.Item */.Z.Item, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://retail.easysunday.com/".concat(i18n.language, "/sunday-car-insurance-ev"),
                                                    children: t("header.motorInsurance.ev")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* default.Item */.Z.Item, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://retail.easysunday.com/".concat(i18n.language, "/sunday-car-insurance"),
                                                    children: t("header.motorInsurance.motor")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* default.Item */.Z.Item, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://easysunday.com/".concat(i18n.language, "/motor"),
                                                    children: t("header.motorInsurance.allProducts")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* default.Item */.Z.Item, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://easysunday.com/".concat(i18n.language, "/motor/claim"),
                                                    children: t("header.motorInsurance.claim")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* default.Item */.Z.Item, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://easysunday.com/".concat(i18n.language, "/motor/#partnergarage"),
                                                    children: t("header.motorInsurance.sundayPartner")
                                                })
                                            })
                                        ]
                                    }, "sub2"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuSubMenu, {
                                        title: t("header.sundayHealthForBusiness.title"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* default.Item */.Z.Item, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://easysunday.com/".concat(i18n.language, "/our-product/health/"),
                                                    children: t("header.sundayHealthForBusiness.about")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* default.Item */.Z.Item, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://easysunday.com/".concat(i18n.language, "/our-product/health/#owner"),
                                                    children: t("header.sundayHealthForBusiness.forBusinessOwner")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* default.Item */.Z.Item, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://easysunday.com/".concat(i18n.language, "/our-product/health/#employee"),
                                                    children: t("header.sundayHealthForBusiness.forEmployee")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* default.Item */.Z.Item, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    href: "https://sundayinsurance.co.th/".concat(i18n.language, "/services/panel/?type=hospital-suncare"),
                                                    children: t("header.sundayHealthForBusiness.sundayHospitalNetwork")
                                                })
                                            })
                                        ]
                                    }, "sub3"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuSubMenu, {
                                        title: t("header.gadgetWarranty.title"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* default.Item */.Z.Item, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "https://easysunday.com/".concat(i18n.language, "/warranty/"),
                                                children: t("header.gadgetWarranty.claim")
                                            })
                                        })
                                    }, "sub5"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* default.Divider */.Z.Divider, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuText, {
                                            onClick: handleGoToAffiliatePage,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: (menus === null || menus === void 0 ? void 0 : (ref1 = menus.sundayAffiliate) === null || ref1 === void 0 ? void 0 : ref1.label) || t("header.sundayAffiliate")
                                            })
                                        })
                                    }, "1"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: (menus === null || menus === void 0 ? void 0 : (ref2 = menus.faq) === null || ref2 === void 0 ? void 0 : ref2.href) || "https://easysunday.com/".concat(i18n.language, "/faq"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: (menus === null || menus === void 0 ? void 0 : (ref3 = menus.faq) === null || ref3 === void 0 ? void 0 : ref3.label) || t("header.faq")
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: (menus === null || menus === void 0 ? void 0 : (ref4 = menus.blog) === null || ref4 === void 0 ? void 0 : ref4.href) || "https://easysunday.com/blog",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: (menus === null || menus === void 0 ? void 0 : (ref5 = menus.blog) === null || ref5 === void 0 ? void 0 : ref5.label) || t("header.blog")
                                            })
                                        })
                                    }, "3"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: (menus === null || menus === void 0 ? void 0 : (ref6 = menus.contactUs) === null || ref6 === void 0 ? void 0 : ref6.href) || "https://easysunday.com/".concat(i18n.language, "/contact-us"),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: (menus === null || menus === void 0 ? void 0 : (ref7 = menus.contactUs) === null || ref7 === void 0 ? void 0 : ref7.label) || t("header.contactus")
                                            })
                                        })
                                    }, "4"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: (menus === null || menus === void 0 ? void 0 : (ref8 = menus.news) === null || ref8 === void 0 ? void 0 : ref8.href) || "https://about.easysunday.com",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                children: (menus === null || menus === void 0 ? void 0 : (ref9 = menus.news) === null || ref9 === void 0 ? void 0 : ref9.label) || t("header.about")
                                            })
                                        })
                                    }, "5"),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* default.Divider */.Z.Divider, {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileMenuLinkBar, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileMenuLinkIcon, {
                                        href: "tel:+6620263355",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            loading: "lazy",
                                            src: "/static/icon-phone-darkgrey.svg",
                                            alt: "phone",
                                            height: "40"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileMenuLinkIcon, {
                                        href: "mailto:hello@easysunday.com",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            loading: "lazy",
                                            src: "/static/icon-email-darkgrey.svg",
                                            alt: "email",
                                            width: "50"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileMenuLinkIcon, {
                                        href: "line://ti/p/@easysunday",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            loading: "lazy",
                                            src: "/static/icon-line-darkgrey.svg",
                                            alt: "line",
                                            width: "44"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var ProfileMainMenu_MobileMainMenu = (MobileMainMenu);

// EXTERNAL MODULE: ./node_modules/antd/es/dropdown/index.js
var dropdown = __webpack_require__(13013);
// EXTERNAL MODULE: ./node_modules/antd/es/list/index.js + 1 modules
var list = __webpack_require__(95507);
// EXTERNAL MODULE: ./node_modules/antd/es/tag/index.js + 1 modules
var tag = __webpack_require__(20550);
// EXTERNAL MODULE: ./node_modules/styled-breakpoints/index.js
var styled_breakpoints = __webpack_require__(94698);
// EXTERNAL MODULE: ./src/components/Common/Button.tsx
var Button = __webpack_require__(55267);
// EXTERNAL MODULE: ./src/components/Common/Divider.tsx
var Divider = __webpack_require__(77208);
;// CONCATENATED MODULE: ./src/components/Common/Header/ProfileHeader/ProfileHeader.style.tsx

function ProfileHeader_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    ProfileHeader_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function ProfileHeader_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid ",
        ";\n  border-radius: 50%;\n  height: 32px;\n  width: 32px;\n"
    ]);
    ProfileHeader_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function ProfileHeader_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: fit-content;\n  margin-right: 40px;\n  ",
        " {\n    margin: 0px;\n  }\n"
    ]);
    ProfileHeader_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function ProfileHeader_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  border: 1px solid ",
        ";\n  border-radius: 50%;\n  height: 40px;\n  width: 40px;\n"
    ]);
    ProfileHeader_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function ProfileHeader_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: ",
        ";\n  max-height: 48px;\n  max-width: 209px;\n\n  &.sunday-component-btn-default {\n    border-radius: 100px;\n    background-color: ",
        ";\n    border-color: ",
        ";\n    * {\n      color: ",
        ";\n    }\n    &:hover {\n      border-radius: 100px;\n      background-color: var(--ui-form-button-primary-enabled-background-color);\n      border-color: ",
        ";\n      * {\n        color: var(--ui-form-button-primary-enabled-text-color);\n      }\n    }\n    &:focus {\n      border-radius: 100px;\n      background-color: ",
        ";\n      border-color: ",
        ";\n      * {\n        color: ",
        ";\n      }\n    }\n    &:disabled {\n      border-radius: 100px;\n      background-color: var(\n        --ui-form-button-secondary-disabled-background-color\n      );\n      border-color: var(--ui-form-button-secondary-disabled-border-color);\n      * {\n        color: var(--ui-form-button-secondary-disabled-text-color);\n      }\n    }\n  }\n\n  &.sunday-component-btn-text {\n    padding: 0px;\n    height: fit-content;\n    width: fit-content;\n    * {\n      color: var(--ui-form-button-text-enabled-text-color);\n    }\n\n    &:hover {\n      * {\n        color: var(--ui-form-button-text-hover-text-color);\n        text-decoration: var(--ui-form-button-text-hover-text-decoration);\n        text-decoration-color: var(--ui-form-button-text-hover-text-color);\n      }\n    }\n    &:focus {\n      * {\n        color: var(--ui-form-button-text-focused-text-color);\n        text-decoration: var(--ui-form-button-text-focused-text-decoration);\n        text-decoration-color: var(--ui-form-button-text-focused-text-color);\n      }\n    }\n    &:disabled {\n      * {\n        color: var(--ui-form-button-text-disabled-text-color);\n        text-decoration: none;\n      }\n    }\n  }\n\n  .sunday-component-btn:active,\n  .sunday-component-btn:focus,\n  .sunday-component-btn:hover {\n    background: ",
        ";\n    border: 1px solid ",
        ";\n  }\n"
    ]);
    ProfileHeader_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function ProfileHeader_style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 10px;\n  max-height: 40px;\n"
    ]);
    ProfileHeader_style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function ProfileHeader_style_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  column-gap: 8px;\n"
    ]);
    ProfileHeader_style_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function ProfileHeader_style_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 153px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    ProfileHeader_style_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function ProfileHeader_style_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    ProfileHeader_style_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function ProfileHeader_style_templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 120px;\n  background-color: white;\n  position: relative;\n  border-bottom-style: solid;\n  border-bottom-width: 1px;\n  border-bottom-color: ",
        ";\n  z-index: 30;\n  @media only screen and (max-width: 767px) {\n    height: 56px;\n  }\n  @media only screen and (min-width: 992px) and (max-width: 1199px) and (orientation: portrait) {\n    height: 56px;\n  }\n  @media only screen and (min-width: 768px) and (max-width: 991px) {\n    height: 56px;\n  }\n"
    ]);
    ProfileHeader_style_templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function ProfileHeader_style_templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  justify-content: space-between;\n"
    ]);
    ProfileHeader_style_templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function ProfileHeader_style_templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n"
    ]);
    ProfileHeader_style_templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  column-gap: 40px;\n  flex-grow: 0;\n  flex-shrink: 0;\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  column-gap: 16px;\n  flex-grow: 0;\n  flex-shrink: 0;\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject14 = function _templateObject14() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  margin-left: 8px;\n"
    ]);
    _templateObject15 = function _templateObject15() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  margin-left: 8px;\n"
    ]);
    _templateObject16 = function _templateObject16() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: white;\n  padding: 0px;\n  border-radius: 8px;\n  overflow: hidden;\n  .ant-dropdown-menu,\n  ul {\n    margin: 0px;\n    padding: 0px;\n  }\n  .ant-dropdown-menu-items {\n    border-radius: 8px;\n    padding: 0px;\n  }\n  .ant-list-item {\n    padding: 16px;\n  }\n"
    ]);
    _templateObject17 = function _templateObject17() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: start;\n  cursor: pointer;\n  &:hover {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject18 = function _templateObject18() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    _templateObject19 = function _templateObject19() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  box-shadow: none;\n  z-index: 999;\n  .ant-drawer-body {\n    padding: 0;\n    height: fit-content;\n  }\n"
    ]);
    _templateObject20 = function _templateObject20() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  cursor: pointer;\n  &:hover {\n    background-color: ",
        ";\n  }\n  padding: 16px;\n"
    ]);
    _templateObject21 = function _templateObject21() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 16px;\n"
    ]);
    _templateObject22 = function _templateObject22() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 178px;\n  max-width: ",
        ";\n  margin-left: 16px;\n"
    ]);
    _templateObject23 = function _templateObject23() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-wrap: break-word;\n  color: ",
        ";\n"
    ]);
    _templateObject24 = function _templateObject24() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject25 = function _templateObject25() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0px;\n"
    ]);
    _templateObject26 = function _templateObject26() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  height: 18px;\n"
    ]);
    _templateObject27 = function _templateObject27() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border-radius: 12px;\n  margin: 0;\n"
    ]);
    _templateObject28 = function _templateObject28() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: white;\n  font-size: 17px;\n"
    ]);
    _templateObject29 = function _templateObject29() {
        return data;
    };
    return data;
}







var MenuDropdown = (0,styled_components_browser_esm/* default */.ZP)(dropdown/* default */.Z).withConfig({
    componentId: "sc-ca0cbe02-0"
})(ProfileHeader_style_templateObject());
var ProfileIconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ca0cbe02-1"
})(ProfileHeader_style_templateObject1(), globals/* color.charcoal03 */.$.charcoal03);
var SundayLogoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ca0cbe02-2"
})(ProfileHeader_style_templateObject2(), (0,styled_breakpoints.down)("md"));
var MobileProfileIconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ca0cbe02-3"
})(ProfileHeader_style_templateObject3(), globals/* color.charcoal03 */.$.charcoal03);
var DesktopLoginButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).attrs({
    type: "outlined"
}).withConfig({
    componentId: "sc-ca0cbe02-4"
})(ProfileHeader_style_templateObject4(), function(props) {
    return props.iconExists ? "7px" : "11px 16px";
}, function(props) {
    return props.active ? "var(--ui-form-button-primary-enabled-background-color)" : "var(--ui-form-button-secondary-enabled-background-color)";
}, function(props) {
    return props.active ? "var(--ui-form-button-primary-enabled-border-color)" : "var(--ui-form-button-secondary-enabled-border-color)";
}, function(props) {
    return props.active ? "var(--ui-form-button-primary-enabled-text-color)" : "var(--ui-form-button-secondary-enabled-text-color)";
}, globals/* color.charcoal03 */.$.charcoal03, function(props) {
    return props.active ? "var(--ui-form-button-primary-enabled-background-color)" : "var(--ui-form-button-secondary-enabled-background-color)";
}, function(props) {
    return props.active ? "var(--ui-form-button-primary-enabled-border-color)" : "var(--ui-form-button-secondary-enabled-border-color)";
}, function(props) {
    return props.active ? "var(--ui-form-button-primary-enabled-text-color)" : "var(--ui-form-button-secondary-enabled-text-color)";
}, globals/* color.carrotOrange03 */.$.carrotOrange03, globals/* color.charcoal03 */.$.charcoal03);
var MobileLoginButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-ca0cbe02-5"
})(ProfileHeader_style_templateObject5());
var LoginButtonBody = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ca0cbe02-6"
})(ProfileHeader_style_templateObject6());
var ButtonTitle = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).attrs({
    level: 7
}).withConfig({
    componentId: "sc-ca0cbe02-7"
})(ProfileHeader_style_templateObject7());
var Header = styled_components_browser_esm/* default.header.withConfig */.ZP.header.withConfig({
    componentId: "sc-ca0cbe02-8"
})(ProfileHeader_style_templateObject8());
var HeaderContainer = (0,styled_components_browser_esm/* default */.ZP)(lib.Container).withConfig({
    componentId: "sc-ca0cbe02-9"
})(ProfileHeader_style_templateObject9(), globals/* color.charcoal03 */.$.charcoal03);
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ca0cbe02-10"
})(ProfileHeader_style_templateObject10());
var Left = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ca0cbe02-11"
})(ProfileHeader_style_templateObject11());
var Right = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ca0cbe02-12"
})(_templateObject12());
var SubMenuContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ca0cbe02-13"
})(_templateObject13());
var MenuIcon = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-ca0cbe02-14"
})(_templateObject14());
var ProfileHeader_style_MenuText = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).withConfig({
    componentId: "sc-ca0cbe02-15"
})(_templateObject15(), globals/* color.charcoal10 */.$.charcoal10);
var LogOutMenuText = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).withConfig({
    componentId: "sc-ca0cbe02-16"
})(_templateObject16(), globals/* color.errorRed02 */.$.errorRed02);
var MenuDropdownList = (0,styled_components_browser_esm/* default */.ZP)(list/* default */.ZP).withConfig({
    componentId: "sc-ca0cbe02-17"
})(_templateObject17());
var MenuDropdownOption = (0,styled_components_browser_esm/* default */.ZP)(list/* default.Item */.ZP.Item).withConfig({
    componentId: "sc-ca0cbe02-18"
})(_templateObject18(), globals/* color.charcoal03 */.$.charcoal03);
var MenuDropdownDisplay = (0,styled_components_browser_esm/* default */.ZP)(list/* default.Item */.ZP.Item).withConfig({
    componentId: "sc-ca0cbe02-19"
})(_templateObject19());
var Drawer = (0,styled_components_browser_esm/* default */.ZP)(drawer/* default */.Z).withConfig({
    componentId: "sc-ca0cbe02-20"
})(_templateObject20());
var DrawerMenuOptionContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ca0cbe02-21"
})(_templateObject21(), globals/* color.charcoal03 */.$.charcoal03);
var DrawerMenuDisplayContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ca0cbe02-22"
})(_templateObject22());
var ProfileInfoContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ca0cbe02-23"
})(_templateObject23(), function(props) {
    return props.fullSize ? "224px" : "178px";
});
var ProfileNameTitle = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).withConfig({
    componentId: "sc-ca0cbe02-24"
})(_templateObject24(), globals/* color.charcoal10 */.$.charcoal10);
var MobileNumberBody = (0,styled_components_browser_esm/* default */.ZP)(lib.Body).withConfig({
    componentId: "sc-ca0cbe02-25"
})(_templateObject25(), globals/* color.charcoal10 */.$.charcoal10);
var ProfileHeader_style_Divider = (0,styled_components_browser_esm/* default */.ZP)(Divider/* default */.Z).withConfig({
    componentId: "sc-ca0cbe02-26"
})(_templateObject26());
var DividerSpace = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ca0cbe02-27"
})(_templateObject27(), globals/* color.charcoal01 */.$.charcoal01);
var NewBadge = (0,styled_components_browser_esm/* default */.ZP)(tag/* default */.Z).attrs({
    color: globals/* color.errorRed03 */.$.errorRed03
}).withConfig({
    componentId: "sc-ca0cbe02-28"
})(_templateObject28());
var NewBadgeText = (0,styled_components_browser_esm/* default */.ZP)(lib.Title).attrs({
    level: 7
}).withConfig({
    componentId: "sc-ca0cbe02-29"
})(_templateObject29());

;// CONCATENATED MODULE: ./src/components/Common/Icons/ProfileMenuIcon.tsx

var ProfileMenuIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M16.6673 17.5V15.8333C16.6673 14.9493 16.3161 14.1014 15.691 13.4763C15.0659 12.8512 14.218 12.5 13.334 12.5H6.66732C5.78326 12.5 4.93542 12.8512 4.31029 13.4763C3.68517 14.1014 3.33398 14.9493 3.33398 15.8333V17.5",
                    stroke: color,
                    strokeWidth: "1.33",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M9.99935 9.16667C11.8403 9.16667 13.3327 7.67428 13.3327 5.83333C13.3327 3.99238 11.8403 2.5 9.99935 2.5C8.1584 2.5 6.66602 3.99238 6.66602 5.83333C6.66602 7.67428 8.1584 9.16667 9.99935 9.16667Z",
                    stroke: color,
                    strokeWidth: "1.33",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        })
    });
};
/* harmony default export */ var Icons_ProfileMenuIcon = (ProfileMenuIcon);

// EXTERNAL MODULE: ./node_modules/antd/es/tooltip/index.js + 1 modules
var tooltip = __webpack_require__(56266);
;// CONCATENATED MODULE: ./src/components/Common/Tooltip/TooltipDesktop.styled.tsx

function TooltipDesktop_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media only screen and (max-width: 1350px) {\n    .ant-tooltip {\n      display: none;\n    }\n  }\n  .ant-tooltip-arrow {\n    left: 83%;\n    width: 30px;\n  }\n  .ant-tooltip-placement-bottom {\n    padding-top: 6px;\n  }\n  .ant-tooltip-arrow-content {\n    width: 14px;\n    height: 14px;\n  }\n"
    ]);
    TooltipDesktop_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TooltipDesktop_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n"
    ]);
    TooltipDesktop_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TooltipDesktop_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  margin-right: 8px;\n"
    ]);
    TooltipDesktop_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TooltipDesktop_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 24px;\n  width: 24px;\n  cursor: pointer;\n"
    ]);
    TooltipDesktop_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var StyledTooptipDesktopContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6da2a3bc-0"
})(TooltipDesktop_styled_templateObject());
var TooltipContentContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-6da2a3bc-1"
})(TooltipDesktop_styled_templateObject1());
var TooltipContentBody = (0,styled_components_browser_esm/* default */.ZP)(lib.Body).attrs({
    level: 7
}).withConfig({
    componentId: "sc-6da2a3bc-2"
})(TooltipDesktop_styled_templateObject2(), globals/* color.white */.$.white);
var TooltipContentImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-6da2a3bc-3"
})(TooltipDesktop_styled_templateObject3());

;// CONCATENATED MODULE: ./src/components/Common/Tooltip/TooltipDesktop.tsx





var TooltipDesktop = function(param) {
    var children = param.children, tooltipContent = param.tooltipContent, tooltipVisible = param.tooltipVisible, setTooltipVisible = param.setTooltipVisible;
    var TooltipContent = /*#__PURE__*/ (0,jsx_runtime.jsxs)(TooltipContentContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipContentBody, {
                children: tooltipContent
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipContentImage, {
                src: "/static/pages/userProfile/x-circle-grayscale.svg",
                alt: "Close Icon",
                onClick: function() {
                    return setTooltipVisible(false);
                }
            })
        ]
    });
    var TooltipInnerStyle = {
        backgroundColor: globals/* color.charcoal10 */.$.charcoal10,
        borderRadius: "8px",
        padding: "12px"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTooptipDesktopContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
            title: TooltipContent,
            color: globals/* color.charcoal10 */.$.charcoal10,
            placement: "bottom",
            visible: tooltipVisible,
            overlayStyle: {
                maxWidth: "100%"
            },
            overlayInnerStyle: TooltipInnerStyle,
            autoAdjustOverflow: {
                adjustX: 0,
                adjustY: 0
            },
            align: {
                targetOffset: [
                    96,
                    2
                ]
            },
            getPopupContainer: function(triggerNode) {
                return triggerNode.parentNode;
            },
            children: children
        })
    });
};
/* harmony default export */ var Tooltip_TooltipDesktop = (TooltipDesktop);

;// CONCATENATED MODULE: ./src/components/Common/Tooltip/TooltipMobile.styled.tsx

function TooltipMobile_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media only screen and (min-width: 1351px) {\n    .ant-tooltip {\n      display: none;\n    }\n  }\n  .ant-tooltip-arrow {\n    left: 80%;\n    width: 30px;\n  }\n  .ant-tooltip-placement-bottom {\n    padding-top: 6px;\n  }\n  .ant-tooltip-arrow-content {\n    width: 14px;\n    height: 14px;\n  }\n"
    ]);
    TooltipMobile_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TooltipMobile_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n"
    ]);
    TooltipMobile_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TooltipMobile_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  margin-right: 8px;\n"
    ]);
    TooltipMobile_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TooltipMobile_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 24px;\n  width: 24px;\n  cursor: pointer;\n"
    ]);
    TooltipMobile_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var StyledTooptipMobileContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9557345d-0"
})(TooltipMobile_styled_templateObject());
var TooltipMobile_styled_TooltipContentContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9557345d-1"
})(TooltipMobile_styled_templateObject1());
var TooltipMobile_styled_TooltipContentBody = (0,styled_components_browser_esm/* default */.ZP)(lib.Body).attrs({
    level: 7
}).withConfig({
    componentId: "sc-9557345d-2"
})(TooltipMobile_styled_templateObject2(), globals/* color.white */.$.white);
var TooltipMobile_styled_TooltipContentImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-9557345d-3"
})(TooltipMobile_styled_templateObject3());

;// CONCATENATED MODULE: ./src/components/Common/Tooltip/TooltipMobile.tsx





var TooltipMobile = function(param) {
    var children = param.children, tooltipContent = param.tooltipContent, tooltipVisible = param.tooltipVisible, setTooltipVisible = param.setTooltipVisible;
    var TooltipContent = /*#__PURE__*/ (0,jsx_runtime.jsxs)(TooltipMobile_styled_TooltipContentContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipMobile_styled_TooltipContentBody, {
                children: tooltipContent
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TooltipMobile_styled_TooltipContentImage, {
                src: "/static/pages/userProfile/x-circle-grayscale.svg",
                alt: "Close Icon",
                onClick: function() {
                    return setTooltipVisible(false);
                }
            })
        ]
    });
    var TooltipInnerStyle = {
        backgroundColor: globals/* color.charcoal10 */.$.charcoal10,
        borderRadius: "8px",
        padding: "12px"
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTooptipMobileContainer, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltip/* default */.Z, {
            title: TooltipContent,
            color: globals/* color.charcoal10 */.$.charcoal10,
            placement: "bottom",
            visible: tooltipVisible,
            overlayStyle: {
                maxWidth: "100%"
            },
            overlayInnerStyle: TooltipInnerStyle,
            autoAdjustOverflow: {
                adjustX: 0,
                adjustY: 0
            },
            align: {
                targetOffset: [
                    96,
                    2
                ]
            },
            getPopupContainer: function(triggerNode) {
                return triggerNode.parentNode;
            },
            children: children
        })
    });
};
/* harmony default export */ var Tooltip_TooltipMobile = (TooltipMobile);

;// CONCATENATED MODULE: ./src/components/Common/CustomBreakpointHook.tsx

var getBreakpoints = function(width, breakpointConfig) {
    return Object.keys(breakpointConfig).reduce(function(accumulator, currentValue) {
        accumulator[currentValue] = breakpointConfig[currentValue] <= width;
        return accumulator;
    }, {});
};
var useCustomBreakpointHook = function(customBreakpointProps) {
    var ref = (0,react.useState)(getBreakpoints((window === null || window === void 0 ? void 0 : window.innerWidth) || 0, customBreakpointProps)), breakpoints = ref[0], setBreakpoints = ref[1];
    (0,react.useLayoutEffect)(function() {
        var handleEventChange = function() {
            var newBreakpoint = getBreakpoints((window === null || window === void 0 ? void 0 : window.innerWidth) || 0, customBreakpointProps);
            setBreakpoints(newBreakpoint);
        };
        var registeredMediaQueryList = window ? Object.keys(customBreakpointProps).map(function(breakpointKey) {
            var widthConfig = customBreakpointProps[breakpointKey];
            var mediaQuery = window.matchMedia("(min-width: ".concat(widthConfig, "px)"));
            mediaQuery.addEventListener("change", handleEventChange);
            return {
                width: customBreakpointProps[breakpointKey],
                mediaQuery: mediaQuery,
                handler: handleEventChange
            };
        }) : [];
        return function() {
            registeredMediaQueryList.forEach(function(registeredMediaQuery) {
                registeredMediaQuery.mediaQuery.removeEventListener("change", registeredMediaQuery.handler);
            });
        };
    }, [
        customBreakpointProps
    ]);
    return breakpoints;
};

;// CONCATENATED MODULE: ./src/components/Common/Header/ProfileHeader/ProfileHeader.tsx

























var NewMenuBadge = function(param) {
    var locale = param.locale;
    var newText = locale === "th" ? "ใหม่!" : "New!";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewBadge, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NewBadgeText, {
            children: newText
        })
    });
};
var menuDropdownList = function(menuList) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuDropdownList, {
        bordered: true,
        dataSource: menuList,
        renderItem: function(item) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    item.divider && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileHeader_style_Divider, {}),
                    item.space && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DividerSpace, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileHeader_style_Divider, {})
                        ]
                    }),
                    item.type === "option" && /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuDropdownOption, {
                        onClick: item.onClick,
                        children: item.render
                    }, item.key),
                    item.type === "display" && /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuDropdownDisplay, {
                        onClick: item.onClick,
                        children: item.render
                    }, item.key)
                ]
            });
        }
    });
};
var menuDrawerList = function(menuList) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            menuList.map(function(item) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        item.divider && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileHeader_style_Divider, {}),
                        item.space && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DividerSpace, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileHeader_style_Divider, {})
                            ]
                        }),
                        item.type === "option" && /*#__PURE__*/ (0,jsx_runtime.jsx)(DrawerMenuOptionContainer, {
                            onClick: item.onClick,
                            children: item.render
                        }),
                        item.type === "display" && /*#__PURE__*/ (0,jsx_runtime.jsx)(DrawerMenuDisplayContainer, {
                            onClick: item.onClick,
                            children: item.render
                        })
                    ]
                });
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileHeader_style_Divider, {})
        ]
    });
};
var MenuOption = function(param) {
    var icon = param.icon, displayName = param.displayName;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
        wrap: false,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuIcon, {
                src: icon,
                height: 24,
                width: 24
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileHeader_style_MenuText, {
                level: 7,
                children: displayName
            })
        ]
    });
};
var ProfileHeader = function(param) {
    var profile = param.profile, isLogin = param.isLogin, onChangeLanguage = param.onChangeLanguage, language = param.language, showSwitchLanguage = param.showSwitchLanguage, menus = param.menus, content = param.content;
    var ref;
    var router = (0,next_router.useRouter)();
    var t = (0,esm/* useTranslation */.$G)("layout").t;
    var ref1 = (0,react.useState)(false), subMenuVisible = ref1[0], setSubMenuVisible = ref1[1];
    var ref2 = (0,react.useState)(false), isLoginModalVisible = ref2[0], setIsLoginModalVisible = ref2[1];
    var ref3 = (0,react.useState)(false), isMenuListOpen = ref3[0], setIsMenuListOpen = ref3[1];
    var ref4 = (0,react.useState)(false), tooltipVisible = ref4[0], setTooltipVisible = ref4[1];
    var availableLanguage = content === null || content === void 0 ? void 0 : content.supportedLangs.map(function(lang) {
        return lang.code;
    });
    var channelPath = typeof router.query.channelPath === "object" ? (ref = router.query.channelPath) === null || ref === void 0 ? void 0 : ref[0] : router.query.channelPath;
    var headerLink = content === null || content === void 0 ? void 0 : content.headerLogoLink;
    var displayName = (profile === null || profile === void 0 ? void 0 : profile.name) && profile.name !== "" ? profile.name : t("header.defaultProfileName");
    var mobileNumber = (0,format/* formatMobileNumberToInternal */.jS)(profile === null || profile === void 0 ? void 0 : profile.contacts.primaryphone);
    var authUrl = "https://auth.easysunday.com";
    var fullHeaderSize = useCustomBreakpointHook({
        fullHeaderSize: 1387
    }).fullHeaderSize;
    (0,react.useEffect)(function() {
        var tooltip = sessionStorage.getItem("newUser");
        setTooltipVisible(!(tooltip === null));
        sessionStorage.removeItem("newUser");
    }, []);
    var handleOpenLoginModal = function() {
        setIsLoginModalVisible(true);
        setIsMenuListOpen(false);
    };
    var handleViewOrder = function() {
        setIsMenuListOpen(false);
        router.push({
            pathname: (0,url/* formatPathByLogicalGroupChannel */.j4)("/".concat(channelPath, "/user/orders")),
            query: (0,url/* filterParams */.Lt)(router.query, params/* GLOBAL_PARAMS */.g_)
        });
    };
    var handleGoToAffiliatePage = function() {
        setIsMenuListOpen(false);
        router.push({
            pathname: (0,url/* formatPathByLogicalGroupChannel */.j4)("/".concat(channelPath, "/affiliate")),
            query: (0,url/* filterParams */.Lt)(router.query, params/* GLOBAL_PARAMS */.g_)
        });
    };
    var handleOnGoToAccountSetting = function() {
        window.open("".concat(authUrl, "/").concat(router.locale, "/setting/profile-info"), "_blank");
        setIsMenuListOpen(false);
    };
    var handleLogOut = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0,auth/* logout */.kS)()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        (0,logger/* logError */.H)("[profile-header] fail on logout", error);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        router.reload();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleLogOut() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCloseMenuList = function() {
        setIsMenuListOpen(false);
    };
    var guestMenuOption = [
        {
            key: "login",
            onClick: handleOpenLoginModal,
            type: "option",
            divider: true,
            render: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuOption, {
                icon: "/static/profile-menu-login.svg",
                displayName: t("header.profileMenu.login")
            })
        },
        {
            key: "signUp",
            onClick: handleOpenLoginModal,
            type: "option",
            divider: true,
            render: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuOption, {
                icon: "/static/profile-menu-sign-up.svg",
                displayName: t("header.profileMenu.signUp")
            })
        },
        {
            key: "affiliate",
            onClick: handleGoToAffiliatePage,
            type: "option",
            divider: true,
            space: true,
            render: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuOption, {
                        icon: "/static/affiliate-icon.svg",
                        displayName: t("header.profileMenu.affiliate")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewMenuBadge, {
                        locale: router.locale
                    })
                ]
            })
        }, 
    ];
    var profileMenuOption = [
        {
            key: "profile",
            type: "display",
            divider: true,
            render: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuIcon, {
                        src: "/static/profile-menu-default-user-icon.svg",
                        height: 48,
                        width: 48
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProfileInfoContainer, {
                        fullSize: !fullHeaderSize,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileNameTitle, {
                                level: 6,
                                children: displayName
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileNumberBody, {
                                level: 7,
                                children: (0,maskData/* maskProfilePhoneNumber */.hA)(mobileNumber)
                            })
                        ]
                    })
                ]
            })
        },
        {
            key: "viewOrder",
            onClick: handleViewOrder,
            type: "option",
            divider: true,
            render: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuOption, {
                icon: "/static/profile-menu-view-order.svg",
                displayName: t("header.profileMenu.viewOrder")
            })
        },
        {
            key: "affiliate",
            onClick: handleGoToAffiliatePage,
            type: "option",
            divider: true,
            render: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuOption, {
                        icon: "/static/affiliate-icon.svg",
                        displayName: t("header.profileMenu.affiliate")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NewMenuBadge, {
                        locale: router.locale
                    })
                ]
            })
        },
        {
            key: "accountSetting",
            onClick: handleOnGoToAccountSetting,
            type: "option",
            divider: true,
            render: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuOption, {
                icon: "/static/profile-menu-account-setting.svg",
                displayName: t("header.profileMenu.accountSetting")
            })
        },
        {
            key: "logOut",
            onClick: handleLogOut,
            type: "option",
            divider: true,
            render: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuIcon, {
                        src: "/static/profile-menu-log-out.svg",
                        height: 24,
                        width: 24
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LogOutMenuText, {
                        level: 7,
                        children: t("header.profileMenu.logout")
                    })
                ]
            })
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthModal/* default */.Z, {
                visible: isLoginModalVisible,
                onClose: setIsLoginModalVisible
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Content, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Left, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SundayLogoContainer, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SundayLogo/* default */.Z, {
                                            content: {
                                                headerLogoLink: headerLink,
                                                headerLogoImageUrl: "https://static.easysunday.com/retail/artifacts/sunday-logo.svg"
                                            }
                                        })
                                    }),
                                    fullHeaderSize && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileMainMenu_MainMenu, {
                                        subMenuVisible: subMenuVisible,
                                        setSubMenuVisible: setSubMenuVisible,
                                        menus: menus
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Right, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubMenuContainer, {
                                    children: [
                                        fullHeaderSize && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib.LanguageSwitcher, {
                                                    availableLanguages: availableLanguage,
                                                    showSwitch: showSwitchLanguage,
                                                    onChangeLanguage: onChangeLanguage,
                                                    language: language
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip_TooltipDesktop, {
                                                    tooltipContent: t("header.tooltip"),
                                                    tooltipVisible: tooltipVisible && isLogin,
                                                    setTooltipVisible: function() {
                                                        return setTooltipVisible(false);
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuDropdown, {
                                                        visible: isMenuListOpen,
                                                        overlay: isLogin ? menuDropdownList(profileMenuOption) : menuDropdownList(guestMenuOption),
                                                        trigger: [
                                                            "click"
                                                        ],
                                                        onVisibleChange: function(visible) {
                                                            // visible menu list for authorized user only
                                                            setIsMenuListOpen(visible);
                                                        },
                                                        overlayStyle: {
                                                            width: "274px"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopLoginButton, {
                                                            iconExists: isLogin,
                                                            active: isMenuListOpen || isLoginModalVisible,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LoginButtonBody, {
                                                                children: [
                                                                    isLogin && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileIconContainer, {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                            src: "/static/profile-menu-default-user-icon.svg",
                                                                            height: 32,
                                                                            width: 32
                                                                        })
                                                                    }),
                                                                    isLogin && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonTitle, {
                                                                        children: displayName
                                                                    }),
                                                                    !isLogin && /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonTitle, {
                                                                        children: t("header.guestProfileMenuTitle")
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        !fullHeaderSize && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Drawer, {
                                                    closable: false,
                                                    placement: "right",
                                                    onClose: handleCloseMenuList,
                                                    visible: isMenuListOpen,
                                                    width: "320",
                                                    bodyStyle: {
                                                        padding: "0px"
                                                    },
                                                    children: [
                                                        !isLogin && menuDrawerList(guestMenuOption),
                                                        isLogin && menuDrawerList(profileMenuOption)
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tooltip_TooltipMobile, {
                                                    tooltipContent: t("header.tooltip"),
                                                    tooltipVisible: tooltipVisible && isLogin,
                                                    setTooltipVisible: function() {
                                                        return setTooltipVisible(false);
                                                    },
                                                    children: [
                                                        isLogin && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileProfileIconContainer, {
                                                            onClick: function() {
                                                                return setIsMenuListOpen(!isMenuListOpen);
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: "/static/profile-menu-default-user-icon.svg",
                                                                height: 40,
                                                                width: 40
                                                            })
                                                        }),
                                                        !isLogin && /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileLoginButton, {
                                                            type: "outlined",
                                                            onClick: function() {
                                                                return setIsMenuListOpen(!isMenuListOpen);
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icons_ProfileMenuIcon, {
                                                                color: globals/* color.carrotOrange03 */.$.carrotOrange03
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileMainMenu_MobileMainMenu, {
                                                    availableLanguage: availableLanguage,
                                                    showSwitch: showSwitchLanguage,
                                                    onChangeLanguage: onChangeLanguage,
                                                    language: language,
                                                    menus: menus
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var ProfileHeader_ProfileHeader = (ProfileHeader);


/***/ }),

/***/ 5671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87379);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @media only screen and (max-width: 767px) {\n    height: 32px;\n    width: auto;\n  }\n  @media only screen and (min-width: 992px) and (max-width: 1199px) and (orientation: portrait) {\n    height: 32px;\n    width: auto;\n  }\n  @media only screen and (min-width: 768px) and (max-width: 991px) {\n    height: 32px;\n    width: auto;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var Logo = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-c35dcea7-0"
})(_templateObject());
var LogoImage = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].img.withConfig */ .ZP.img.withConfig({
    componentId: "sc-c35dcea7-1"
})(_templateObject1());
var SundayLogo = function(param) {
    var content = param.content;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Logo, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
            href: content === null || content === void 0 ? void 0 : content.headerLogoLink,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(LogoImage, {
                loading: "lazy",
                height: "62",
                src: content === null || content === void 0 ? void 0 : content.headerLogoImageUrl,
                alt: "sunday-logo"
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SundayLogo);


/***/ }),

/***/ 65791:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YY": function() { return /* binding */ maskPhoneNumber; },
/* harmony export */   "cY": function() { return /* binding */ maskBankAccountNumber; },
/* harmony export */   "hA": function() { return /* binding */ maskProfilePhoneNumber; },
/* harmony export */   "ln": function() { return /* binding */ maskCitizenId; },
/* harmony export */   "mX": function() { return /* binding */ maskPassportNo; },
/* harmony export */   "of": function() { return /* binding */ maskEmail; }
/* harmony export */ });
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_0__);

var maskPhoneNumber = function(number) {
    var maskSymbol = "•";
    if (number) {
        if ((0,lodash__WEBPACK_IMPORTED_MODULE_0__.startsWith)("0", number)) {
            return "".concat(number.substring(0, 3), " ").concat(number.substring(3, 6).replace(/./g, maskSymbol), " ").concat(number.substring(6, 8));
        // .replace(/./g, maskSymbol)}${number.substring(8)}`;
        }
        // 66123456789 -> 661 2345 6789
        if ((0,lodash__WEBPACK_IMPORTED_MODULE_0__.startsWith)("66", number)) {
            return "".concat(number.substring(0, 3), " ").concat(number.substring(3, 7).replace(/./g, maskSymbol), " ").concat(number.substring(7, 9));
        // .replace(/./g, maskSymbol)}${number.substring(9)}`;
        }
        // +66123456789 -> +661 2345 6789
        if ((0,lodash__WEBPACK_IMPORTED_MODULE_0__.startsWith)("+66", number)) {
            return "".concat(number.substring(0, 4), " ").concat(number.substring(4, 8).replace(/./g, maskSymbol), " ").concat(number.substring(8, 10));
        // .replace(/./g, maskSymbol)}${number.substring(10)}`;
        }
        // default case
        return "".concat(number.substring(0, 4), " ").concat(number.substring(4, 8).replace(/./g, maskSymbol), " ").concat(number.substring(8, 10));
    // .replace(/./g, maskSymbol)}${number.substring(10)}`;
    }
    return "";
};
var maskEmail = function(email) {
    var maskSymbol = "•";
    if (email) {
        return "".concat(email.substring(0, 3), " ").concat(maskSymbol.repeat(email.substring(3).length));
    }
    return "";
};
var maskProfilePhoneNumber = function(number) {
    var maskSymbol = "*";
    var trimMobileNo = number === null || number === void 0 ? void 0 : number.replace(/\D/g, "");
    if (trimMobileNo) {
        if ((0,lodash__WEBPACK_IMPORTED_MODULE_0__.startsWith)("0", trimMobileNo)) {
            return "".concat(trimMobileNo.substring(0, 2)).concat(trimMobileNo.substring(2, 5).replace(/./g, maskSymbol)).concat(trimMobileNo.substring(5, 8));
        // .replace(/./g, maskSymbol)}${trimMobileNo.substring(8)}`;
        }
        // 66123456789 -> 66123456789
        if ((0,lodash__WEBPACK_IMPORTED_MODULE_0__.startsWith)("66", trimMobileNo)) {
            return "".concat(trimMobileNo.substring(0, 2)).concat(trimMobileNo.substring(2, 6).replace(/./g, maskSymbol)).concat(trimMobileNo.substring(6, 9));
        // .replace(/./g, maskSymbol)}${trimMobileNo.substring(9)}`;
        }
        // +66123456789 -> +66123456789
        if ((0,lodash__WEBPACK_IMPORTED_MODULE_0__.startsWith)("+66", trimMobileNo)) {
            return "".concat(trimMobileNo.substring(0, 4)).concat(trimMobileNo.substring(4, 7).replace(/./g, maskSymbol)).concat(trimMobileNo.substring(7, 10));
        // .replace(/./g, maskSymbol)}${trimMobileNo.substring(10)}`;
        }
        // default case
        return "".concat(trimMobileNo.substring(0, 3)).concat(trimMobileNo.substring(3, 7).replace(/./g, maskSymbol)).concat(trimMobileNo.substring(7, 10));
    // .replace(/./g, maskSymbol)}${number.substring(10)}`;
    }
    return "";
};
var maskBankAccountNumber = function(accountNumber, maskSymbol) {
    var defaultMaskedString = "************";
    var prefixMaskedSymbol = maskSymbol ? defaultMaskedString.replace(/./g, "*") : defaultMaskedString;
    var suffixAccountNumber = accountNumber.slice(accountNumber.length - 4, accountNumber.length);
    return "".concat(prefixMaskedSymbol).concat(suffixAccountNumber);
};
var maskCitizenId = function(citizenId, maskSymbol) {
    var defaultMaskedString = "*********";
    var prefixMaskedSymbol = maskSymbol ? defaultMaskedString.replace(/./g, "*") : defaultMaskedString;
    var suffixCitizenId = citizenId.slice(citizenId.length - 4, citizenId.length);
    return "".concat(prefixMaskedSymbol).concat(suffixCitizenId);
};
var maskPassportNo = function(passportNo, maskSymbol) {
    var defaultMaskedString = "*****";
    var prefixMaskedSymbol = maskSymbol ? defaultMaskedString.replace(/./g, "*") : defaultMaskedString;
    var suffixCitizenId = "";
    if (passportNo.length <= 4) {
        suffixCitizenId = passportNo.slice(passportNo.length - 1, passportNo.length);
    } else {
        suffixCitizenId = passportNo.slice(passportNo.length - 4, passportNo.length);
    }
    return "".concat(prefixMaskedSymbol).concat(suffixCitizenId);
};


/***/ })

}]);